import React from 'react';
import styled from 'styled-components';
import CustomButton from '../../../../../Button/CustomButton.tsx';
import CloseIcon from '@mui/icons-material/Close';

const CardTwo = (props) => {
  const diagnostico = props.datos;
  
  return (
    <CardStyled>
      {
        <div className="divBody">
          <div className="divDatos">
            <ul>
              <li><span className="span">Orden de Trabajo:</span>
                <span className="spann">{diagnostico?.orden_trabajo?.description}{" "} ({diagnostico?.orden_trabajo?.nro_lote_otra})</span>
              </li>
              <li><span className="span">Conjunto de Análisis:</span> <span className="spann">{diagnostico.conjunto_analisis.description}</span></li>
              <li><span className="span">Cantidad de Resultados (Cargados/totales):</span> <span className="spann">{diagnostico.contador}</span></li>
            </ul>
          </div>
          <div className="divButtons">
            <p className="title">Estado de la Muestra</p>
            <CustomButton
              label={diagnostico.estado_mue.toUpperCase()}
              variant="contained"
              className="btnEstado"
              size="large" />
            <CustomButton
              label="Cancelar"
              startIcon={<CloseIcon />}
              onClick={() => {
                if (props.onClick) {
                  props.onClick();
                }
              }}
              classNameDiv="btnClose"
              className="buttonColorTable"
              size="small" />
          </div>
        </div>
      }
    </CardStyled>
  );
};

export default CardTwo

const CardStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  .divHeader {
    display: flex;
    gap: 10px;
  }
  .divCP {
    width: 75%;
  }
  .divNMuestra,
  .divCP {
    display: flex;
    flex-direction: column;
    .label {
      font-family: "Inter", sans-serif;
      font-size: 4px;
      color: #545454;
      font-weight: 400;
      margin: 5px;
    }

    .divBody {
      background: #dbe5e8;
      border-radius: 10px;
      border: 1px solid #afccd5;
      padding: 15px;
      .labelBody {
        font-family: "Work Sans", sans-serif;
        font-weight: 600;
        font-size: 16px;
        color: #163c5b;
        margin: 0px;
      }
    }
  }
  .divBody {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    .divDatos {
      display: flex;
      flex-direction: column;
      width: 60%;
      ul {
        list-style-type: none;
        padding: 0px;
        margin: 0px;
        li {
          margin-bottom: 10px;
          .span,
          .spann {
            font-family: "Inter", sans-serif;
          }
          .span {
            color: #545454;
            display: inline-block;
            
            font-size: 15px;
          }
          .spann {
            color: #163c5b;
            font-weight: bold;
            font-size: 17px;
          }
        }
      }
    }
    .divButtons {
      display: flex;
      flex-direction: column;
      gap: 10px;
      .btnEstado {
        width: 173px;
        background-color: #66bbd3;
      }
      .btnClose {
        margin-left: auto;
        button{
        font-size: 15px;
      }
      }
      .title {
        margin: 0px;
        font-family: "Inter", sans-serif;
        color: #545454;
        font-size: 13px;
        font-weight: 600;
        text-align: center;
      }
    }
  }
`;